import * as React from 'react';

export function SvgConfluence() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 24 24">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
          fill="#1868DB"
        />
        <path
          d="M17.8878 14.4612C13.8492 12.5084 12.6693 12.2166 10.9676 12.2166C8.97101 12.2166 7.26933 13.0471 5.74916 15.3815L5.49958 15.7631C5.29538 16.0773 5.25 16.1896 5.25 16.3242C5.25 16.4589 5.31807 16.5712 5.56765 16.7283L8.13151 18.322C8.26765 18.4117 8.38109 18.4566 8.49454 18.4566C8.63067 18.4566 8.72143 18.3893 8.85756 18.1873L9.26597 17.5588C9.90126 16.5936 10.4685 16.2794 11.1945 16.2794C11.8298 16.2794 12.5786 16.4589 13.5088 16.9078L16.1861 18.1648C16.4584 18.2995 16.7534 18.2322 16.8895 17.9179L18.1601 15.1346C18.2962 14.8203 18.2055 14.6183 17.8878 14.4612ZM6.11218 9.54548C10.1508 11.4983 11.3307 11.7901 13.0324 11.7901C15.029 11.7901 16.7307 10.9596 18.2508 8.62518L18.5004 8.2436C18.7046 7.92935 18.75 7.81712 18.75 7.68244C18.75 7.54776 18.6819 7.43553 18.4324 7.27841L15.8685 5.68473C15.7324 5.59494 15.6189 5.55005 15.5055 5.55005C15.3693 5.55005 15.2786 5.61739 15.1424 5.8194L14.734 6.4479C14.0987 7.41309 13.5315 7.72733 12.8055 7.72733C12.1702 7.72733 11.4214 7.54776 10.4912 7.09884L7.81387 5.84185C7.5416 5.70717 7.24664 5.77451 7.1105 6.08876L5.83992 8.87209C5.70378 9.18634 5.79454 9.38836 6.11218 9.54548Z"
          fill="white"
        />
      </svg>
    </span>
  );
}
